import { HttpError } from '@wix/http-client'
import type { HttpClient } from '@wix/http-client'

const url = '/_api/premium-store/plans/premiumStatus'

export const getPremiumState = async ({
  httpClient,
  metaSiteId,
}: {
  httpClient: HttpClient
  metaSiteId: string
}): Promise<'FREE' | 'PREMIUM_MAX_PLAN' | 'PREMIUM' | undefined> => {
  try {
    const { data: premiumStatus } = await httpClient.get(url, {
      params: { metaSiteId },
    })
    return premiumStatus.premiumState || premiumStatus.payload.premiumState
  } catch (cause) {
    if (cause instanceof HttpError && cause.response?.status === 404) {
      // site was deleted, so instead of throwing an error, just return no value
      return
    }
    throw new Error('Failed to retrieve premium status', { cause })
  }
}
